import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteLeaderCriteria = () => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (leaderCriteriaId: string) =>
      await request(`${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}`, {
        method: "DELETE",
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "leaders.qualification.delete.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["leaderCriteria", sport, organizationId] });
    },
  });
};
